import { DiscordIcon, LinkedinIcon, TiktokIcon, TwitterIcon } from "./Footer.icons";

export const footerSocialMedia = [
  { icon: <DiscordIcon />, title: "Discord", link: "https://discord.com/invite/7NFVRymVZf" },
  { icon: <TwitterIcon />, title: "Twitter", link: "https://twitter.com/_WEB3M_" },
  { icon: <LinkedinIcon />, title: "Linkedin", link: "https://il.linkedin.com/company/web3-m" },
  { icon: <TiktokIcon />, title: "Tiktok", link: "https://www.tiktok.com/@web3m" },
];
